(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("k1qPL", function(module, exports) {
const $e938b74913533b95$var$userItems = document.querySelectorAll(".i-user");
$e938b74913533b95$var$userItems.forEach((item)=>{
    const dropdown = document.querySelector(".i-header-dropdown");
    if (!dropdown) return;
    item.addEventListener("click", (e)=>{
        dropdown.classList.add("--open");
        e.preventDefault();
    });
});

});

})();
//# sourceMappingURL=user-item.60f04d20.js.map
